import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function CloseCircle({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
        fill="white"
      />
      <Path
        d="M11.7071 13.1213L16 17.4142L17.4142 16L13.1213 11.7071L17.4142 7.41421L16 6L11.7071 10.2929L7.41421 6L6 7.41421L10.2929 11.7071L6 16L7.41421 17.4142L11.7071 13.1213Z"
        fill={iconColor}
      />
    </Svg>
  );
}
